<script lang="ts">import { icon, iconActive, iconHover } from "./colors";
export let size = 20;
export let active = false;
export let hover = false;
export let color = undefined;
let width = size;
let height = size;
let fill = color ? color : active ? iconActive : hover ? iconHover : icon;
$: fill = color ? color : active ? iconActive : hover ? iconHover : icon;
</script>

<svg fill="none" {height} viewBox="0 0 17 17" {width} xmlns="http://www.w3.org/2000/svg">
	<g clip-path="url(#clip0_4680_49395)">
		<g clip-path="url(#clip1_4680_49395)">
			<path
				d="M11.3249 16.9892C9.42239 16.9892 7.55263 16.9892 5.66648 16.9892C5.66648 16.9147 5.66648 16.8477 5.66648 16.7806C5.66648 14.3222 5.68288 11.8564 5.65828 9.39806C5.65008 8.54136 6.33073 7.86344 7.31481 7.88579C8.10208 7.90069 8.89754 7.88579 9.68481 7.89324C10.6853 7.89324 11.3249 8.46686 11.3249 9.37571C11.3249 11.849 11.3249 14.3222 11.3249 16.7955C11.3249 16.8477 11.3249 16.9073 11.3249 16.9892Z"
				{fill}
			/>
			<path
				d="M4.34636 9.88185C4.34636 12.2508 4.34636 14.6124 4.34636 16.9888C4.26435 16.9888 4.19875 16.9962 4.12494 16.9962C3.29667 16.9962 2.4684 16.9962 1.63193 16.9962C0.639653 16.9962 0 16.4152 0 15.5138C0 14.1207 0 12.7351 0 11.342C0 10.4629 0.639653 9.88185 1.60733 9.8744C2.4602 9.86696 3.30487 9.8744 4.15774 9.8744C4.22335 9.8744 4.28075 9.88185 4.34636 9.88185Z"
				{fill}
			/>
			<path
				d="M8.49531 0.00390625C8.77414 0.00390625 8.97915 0.108201 9.10216 0.339139C9.33998 0.786115 9.586 1.22564 9.82382 1.67262C9.88123 1.77691 9.93863 1.82906 10.078 1.84396C10.6193 1.90356 11.1523 1.9855 11.6936 2.05255C11.9724 2.0898 12.1774 2.21644 12.2676 2.46228C12.3578 2.70811 12.2758 2.92415 12.079 3.10294C11.6854 3.44562 11.2999 3.79576 10.9063 4.13844C10.7997 4.22783 10.7833 4.30978 10.8079 4.42897C10.9063 4.9132 10.9883 5.40487 11.0867 5.88909C11.1359 6.14238 11.0539 6.34352 10.8325 6.49251C10.6111 6.64151 10.3651 6.64895 10.119 6.52976C9.62701 6.29137 9.13497 6.05299 8.63473 5.8295C8.56092 5.79225 8.43791 5.7997 8.3641 5.8295C7.88846 6.04554 7.42103 6.26902 6.95359 6.49996C6.69117 6.63406 6.42874 6.6713 6.16632 6.49996C5.9203 6.33607 5.8629 6.11258 5.9203 5.8444C6.01871 5.36762 6.09252 4.89085 6.19092 4.42152C6.21553 4.30233 6.19092 4.22783 6.09252 4.14589C5.71529 3.8181 5.34625 3.47542 4.96082 3.14764C4.7394 2.95395 4.62459 2.74536 4.723 2.46973C4.82141 2.19409 5.05103 2.08235 5.35446 2.05255C5.8793 1.99295 6.40414 1.91846 6.92898 1.83651C7.01099 1.82161 7.1094 1.75456 7.1504 1.68752C7.40462 1.24054 7.64244 0.793564 7.88846 0.346588C8.01147 0.11565 8.21649 0.00390625 8.49531 0.00390625Z"
				{fill}
			/>
			<path
				d="M12.6445 16.9814C12.6445 15.268 12.6445 13.5695 12.6445 11.8561C12.7183 11.8561 12.7839 11.8486 12.8495 11.8486C13.6942 11.8486 14.5389 11.8486 15.3836 11.8486C16.3512 11.8486 16.9991 12.4297 16.9991 13.3088C16.9991 14.0537 16.9991 14.8061 16.9991 15.5511C16.9991 16.3705 16.3758 16.974 15.482 16.9889C14.5799 17.0038 13.6696 16.9963 12.7675 16.9963C12.7265 16.9963 12.6937 16.9889 12.6445 16.9814Z"
				{fill}
			/>
		</g>
	</g>
	<defs>
		<clipPath id="clip0_4680_49395">
			<rect {fill} height="17" transform="translate(0 0.00390625)" width="17" />
		</clipPath>
		<clipPath id="clip1_4680_49395">
			<rect {fill} height="17" transform="translate(0 0.00390625)" width="17" />
		</clipPath>
	</defs>
</svg>
